import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <p className="footer-text">
        This website is a personal portfolio project and is not affiliated with,
        endorsed by, or sponsored by Burger King Corporation.
      </p>
    </footer>
  );
}

export default Footer;
